import { render, staticRenderFns } from "./ColorCard.vue?vue&type=template&id=13327131&scoped=true&"
import script from "./ColorCard.vue?vue&type=script&lang=js&"
export * from "./ColorCard.vue?vue&type=script&lang=js&"
import style0 from "./ColorCard.vue?vue&type=style&index=0&id=13327131&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13327131",
  null
  
)

export default component.exports